import Layout from "@/components/layout/Layout";
import SEO, { localBusinessSchema } from "@/components/SEO";
import Hero from "@/components/home/Hero";
import Services from "@/components/home/Services";
import Craftsmanship from "@/components/home/Craftsmanship";
import About from "@/components/home/About";
import Gallery from "@/components/home/Gallery";
import MiracleCoat from "@/components/home/MiracleCoat";
import Clients from "@/components/home/Clients";
import CTA from "@/components/home/CTA";

const Index = () => {
  return (
    <Layout>
      <SEO
        title="Hyper Haus | LA's Premier Hypercar Protection & Customization"
        description="Los Angeles' premier hypercar protection shop. 30+ years of expertise in PPF, ceramic coating, window tint, custom wraps, and detailing. Serving Beverly Hills, Hawthorne & greater LA."
        canonical="/"
        jsonLd={localBusinessSchema}
      />
      <Hero />
      <Services />
      <Craftsmanship />
      <About />
      <MiracleCoat />
      <Gallery />
      <Clients />
      <CTA />
    </Layout>
  );
};

export default Index;
